"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDate = exports.DateContext = void 0;
const react_1 = __importDefault(require("react"));
exports.DateContext = react_1.default.createContext({});
/** Use entire Date Context */
exports.useDate = () => react_1.default.useContext(exports.DateContext);
